export const PROJECT_ACTION_MENU_GAP = 6;
export const PROJECT_ACTION_MENU_VIEWPORT_PADDING = 12;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getProjectActionMenuPosition = (
  triggerRect,
  menuRect,
  viewport,
) => {
  const gap = PROJECT_ACTION_MENU_GAP;
  const padding = PROJECT_ACTION_MENU_VIEWPORT_PADDING;
  const menuWidth = menuRect.width;
  const menuHeight = menuRect.height;
  const maxLeft = Math.max(padding, viewport.width - padding - menuWidth);
  const left = clamp(triggerRect.right - menuWidth, padding, maxLeft);
  const spaceBelow = viewport.height - padding - triggerRect.bottom;
  const spaceAbove = triggerRect.top - padding;
  const opensUpward =
    spaceBelow < menuHeight + gap && spaceAbove > spaceBelow;
  const preferredTop = opensUpward
    ? triggerRect.top - gap - menuHeight
    : triggerRect.bottom + gap;
  const maxTop = Math.max(padding, viewport.height - padding - menuHeight);

  return {
    left,
    top: clamp(preferredTop, padding, maxTop),
    placement: opensUpward ? "top" : "bottom",
  };
};
